import { render, staticRenderFns } from "./LostDetail.vue?vue&type=template&id=3ce0cb48&scoped=true&"
import script from "./LostDetail.vue?vue&type=script&lang=js&"
export * from "./LostDetail.vue?vue&type=script&lang=js&"
import style0 from "./LostDetail.vue?vue&type=style&index=0&id=3ce0cb48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0cb48",
  null
  
)

export default component.exports